export default "__VITE_ASSET__DElT3SC9__"